<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    hotel_class
                </mat-icon>
                <span>
                    Resource: {{ itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ avatarUrl }}" isApiImage="{{ isApiImage }}" className="app-image-medium app-image-circle"></app-image>
                        <button *ngIf="itemEnvelope?.ItemId" mat-button class="button-mini button-inconspicuous avatar-button" (click)="editAvatar()">
                            <mat-icon class="material-symbols-outlined">
                                edit
                            </mat-icon>
                            EDIT
                        </button>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="FirstName" placeholder="First Name" [(ngModel)]="$any(itemEnvelope).Document.Person.FirstName" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="LastName" placeholder="Last Name" [(ngModel)]="$any(itemEnvelope).Document.Person.LastName" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                    <form>
                        <span>
                            <app-chip-selector #resourceTypeChipSelector label="Resource Types" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableResourceTypes" [value]="selectedResourceTypeIds"></app-chip-selector>
                        </span>
                        <br />
                        <span>
                            <app-chip-selector #citizenshipChipSelector label="Citizenship" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableCitizenships" [value]="selectedCitizenshipIds"></app-chip-selector>
                        </span>
                    </form>
                </mat-tab>
                <mat-tab *ngIf="isActor" label="{{ actorTabLabel }}">
                    <br />
                    <form>
                        <br />
                        <button mat-button (click)="addActingProfile()">
                            <mat-icon class="material-symbols-outlined">
                                add
                            </mat-icon>
                            ADD NEW PROFILE
                        </button>
                        <br />
                        <br />
                        <div class="acting-profile-card-container">
                            <div *ngFor="let actingProfile of availableActingProfiles" class="editor-badge">
                                <mat-form-field appearance="outline" style="width: 400px;">
                                    <input matInput value="xxx" style="display: none;" />
                                    <mat-label>{{ actingProfile.Name }}</mat-label>
                                    <div style="display: flex; flex-direction: column;">
                                        <div style="display: flex; flex-direction: row;">
                                            <div style="padding: 8px;margin-right: 8px;">
                                                <app-image srcPath="{{ actingProfile.AvatarBlobPath }}" isApiImage="{{ isApiImage }}" className="app-image-small app-image-circle"></app-image>
                                            </div>
                                            <div style="display: flex; flex-direction: column;padding: 8px;margin-top:8px;">
                                                <span style="display:inline-flex">Range: <div class="text-flash-narrow">{{ actingProfile.AgeRangeYearsLower }} - {{ actingProfile.AgeRangeYearsUpper }}</div></span>
                                                <span style="display:inline-flex">Ethnicity: <div class="text-flash-narrow">{{ getEthnicityUIDsFromActingProfileId(actingProfile.ActingProfileId) }}</div></span>
                                                <span style="display:inline-flex">Can Play: <div class="text-flash-narrow">{{ getCharacterTypeUIDsFromActingProfileId(actingProfile.ActingProfileId) }}</div></span>
                                            </div>
                                        </div>
                                        <div class="text-flash-medium-wrapped">
                                            {{ actingProfile.Pitch }}
                                        </div>
                                        <div style="display:flex; flex-direction: row; padding-left: 180px;margin-top:24px;">
                                            <button mat-button (click)="deleteActingProfile(actingProfile)">
                                                <mat-icon class="material-symbols-outlined">
                                                    delete
                                                </mat-icon>
                                                DELETE
                                            </button>
                                            <button mat-button (click)="showActingProfileDialog(actingProfile)">
                                                <mat-icon class="material-symbols-outlined">
                                                    edit
                                                </mat-icon>
                                                EDIT
                                            </button>
                                        </div>
                                    </div>
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Engagements">
                    <br />
                    <button mat-button (click)="addEngagement()">
                        <mat-icon class="material-symbols-outlined">
                            add
                        </mat-icon>
                        ADD NEW ENGAGEMENT
                    </button>
                    <br />
                    <br />
                    <table mat-table *ngIf="itemEnvelope" [dataSource]="engagementsDatasource" class="search-result mat-elevation-z8" matSort>
                        <ng-container matColumnDef="Avatar">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                <app-image srcPath="{{ getProductionAvatarBlobPathFromEngagement(engagement) }}" isApiImage="true" (click)="editEngagement(engagement)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ProductionName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getProductionNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="RoleName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getProductionRoleNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="EngagementStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getEngagementStatusNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="StartOnUTC">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Start On </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ engagement.StartOnUTC }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Delete">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let engagement">
                                <button mat-button (click)="deleteEngagement(engagement)">
                                    <mat-icon class="material-symbols-outlined">
                                        delete
                                    </mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedEngagementsColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedEngagementsColumns"></tr>
                    </table>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>


